<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay scrollable persistent>
    <v-card>
      <v-toolbar dense color="primary" dark tabs>
        <v-toolbar-title>
          {{
            selected._id
              ? $t('titles.global.updateModel', { field: $tc('models.entity') })
              : $t('titles.global.newModel', { field: $tc('models.entity') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-tabs
          slot="extension"
          v-model="tab"
          color="primary"
          slider-color="white"
          centered
        >
          <v-tab>{{ $tc('models.entity') }}</v-tab>
          <v-tab :disabled="!selected._id">
            {{ $tc('models.team', 2) }}
          </v-tab>
          <v-tab :disabled="!selected._id">
            {{ $tc('models.user', 2) }}
          </v-tab>
          <v-tab :disabled="!selected._id"> SMTP </v-tab>
          <v-tab v-if="isAdmin || canSetSubscription" :disabled="!selected._id">
            {{ $tc('models.subscription', 2) }}
          </v-tab>
          <v-tab v-if="isAdmin" :disabled="!selected._id">
            {{ $t('models.entitySubscription') }}
          </v-tab>
          <v-tab :disabled="!selected._id">
            {{ $t('models.tempTeams') }}
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item ripple>
            <tab-information ref="tabInformation" @close="cancel" />
          </v-tab-item>
          <v-tab-item ripple>
            <v-layout v-if="selected._id" row wrap>
              <v-flex xs12 md10 offset-md1>
                <tab-teams :entity-id="selected._id" entity-view />
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item ripple>
            <entity-users v-if="selected._id" :entity-id="selected._id" />
          </v-tab-item>
          <v-tab-item ripple>
            <tab-mail-config v-if="selected._id" />
          </v-tab-item>
          <v-tab-item v-if="isAdmin || canSetSubscription" ripple>
            <tab-subscriptions :id="selected._id" />
          </v-tab-item>
          <v-tab-item v-if="isAdmin" ripple>
            <tab-subscriptions-entity :id="selected._id" />
          </v-tab-item>
          <v-tab-item ripple>
            <tab-temp-team :id="selected._id" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TabTeams from '../teams/Dashboard'
import TabSubscriptionsEntity from './TabEntitySubscription'
import TabInformation from './TabInformation'
import TabSMTP from './TabSMTP'
import TabSubscriptions from './TabSubscriptions'
import TabTempTeam from './TabTempTeam'
import EntityUsers from './entity-users/EntityUsers'

export default {
  name: 'EntityForm',
  components: {
    TabInformation,
    TabTeams,
    EntityUsers,
    'tab-mail-config': TabSMTP,
    TabSubscriptions,
    TabSubscriptionsEntity,
    TabTempTeam,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    tab(val) {
      this.$nextTick(() => {
        if (val === 2) this.fetchUsers({ entity: this.selected._id, limit: 0 })
        // else if (val === 1) this.fetchUsers({ limit: 0 })
      })
    },
  },
  computed: {
    ...mapState({
      selected: (state) => state.entities.selected,
      idSelected: (state) => state.entities.idSelected,
    }),
    canSetSubscription() {
      return this.authUser.roles.some(
        (role) =>
          role.roleId.id === '62e829b6868951330cfdab48' ||
          role.roleId.id === '5ebdd4ab147d097f81ca2c6a'
      )
    },
  },
  methods: {
    ...mapActions({
      reset: 'entities/reset',
      resetTeamState: 'teams/resetState',
      fetchUsers: 'users/fetchList',
    }),
    cancel() {
      this.$emit('close')
      this.clear()
    },
    clear() {
      this.$nextTick(() => {
        this.reset()
        this.resetTeamState()
        if (this.$refs.tabInformation) this.$refs.tabInformation.clear()
        this.tab = 0
      })
    },
  },
}
</script>
